import { render, staticRenderFns } from "./tooltipResultados.vue?vue&type=template&id=735e750a&scoped=true&"
import script from "./tooltipResultados.vue?vue&type=script&lang=js&"
export * from "./tooltipResultados.vue?vue&type=script&lang=js&"
import style0 from "./tooltipResultados.vue?vue&type=style&index=0&id=735e750a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e750a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VMenu,VProgressCircular})
